/**
 * 일반 응답과 OMR 입력의 상태 분류.
 * 미응답·입력 오류·모름·응답을 섞지 않는다. 정오 채점은 이 모듈에서 하지 않는다.
 */
function assertOptionCount(optionCount) {
    if (!Number.isInteger(optionCount) || optionCount < 1)
        throw new Error(`invalid optionCount: ${optionCount}`);
}
export function classifyScreenInput(input, optionCount) {
    assertOptionCount(optionCount);
    switch (input.kind) {
        case 'blank':
            return { state: 'unanswered', value: null };
        case 'dont-know':
            return { state: 'dont-know', value: null };
        case 'choice':
            if (Number.isInteger(input.value) && input.value >= 1 && input.value <= optionCount) {
                return { state: 'answered', value: input.value };
            }
            return { state: 'input-error', value: null };
    }
}
/**
 * OMR 입력(종이 문제지 답을 학생이 옮겨 적은 값).
 * - 빈 값 → 미응답
 * - 1..보기 수 사이의 정수 한 개 → 응답
 * - 그 밖(범위 밖, 여러 개, 문자 등) → 입력 오류. 원본 보존.
 * 종이 OMR에는 '모름' 표기가 정해지지 않아 이 함수는 모름을 만들지 않는다.
 */
export function classifyOmrInput(raw, optionCount) {
    assertOptionCount(optionCount);
    const original = raw ?? '';
    const trimmed = original.trim();
    if (trimmed === '')
        return { state: 'unanswered', value: null, raw: original };
    if (/^[0-9]+$/.test(trimmed)) {
        const n = Number(trimmed);
        if (n >= 1 && n <= optionCount)
            return { state: 'answered', value: n, raw: original };
    }
    return { state: 'input-error', value: null, raw: original };
}
